/**
 * 基础请求参数接口
 */
export interface RequestParams {
  [key: string]: unknown
}

/**
 * 核心返回结果类
 */
export class ResultClass<T = any> {
  data: T | null = null
  status: boolean = false
  parameters: RequestParams = {}

  static of<T>(data?: T, status?: boolean): ResultClass<T> {
    const result = new ResultClass<T>()
    result.data = data || null
    result.status = status || false
    return result
  }

  /**
   * 转换为分页数据结构
   */
  toPageData(): PageData<any> {
    return PageData.from(this.data, (this.parameters as any).page || 1)
  }

  /**
   * 转换为列表数据结构
   */
  toListData(): ListData<any> {
    return ListData.from(this.data)
  }
}

/**
 * 分页数据结构
 */
export class PageData<T> {
  hasMore: boolean = false
  totalCount: number = 0
  items: T[] = []
  currentPage: number = 1

  static from<T>(data: any, currentPage: number): PageData<T> {
    const page = new PageData<T>()
    page.items = data?.contents || []
    page.totalCount = data?.totalElements || 0
    page.hasMore = page.totalCount > page.items.length && page.items.length !== 0
    page.currentPage = currentPage
    return page
  }
}

/**
 * 列表数据结构
 */
export class ListData<T> {
  items: T[] = []

  static from<T>(data: any): ListData<T> {
    const list = new ListData<T>()
    list.items = Array.isArray(data) ? data : (data?.items || [])
    return list
  }
}
